import { OnlyKeys } from '@dev-fast/types';

export const flatenObjByKeys = <T>(keys: OnlyKeys<T>[], obj: T) => {
  return keys.map((val) => obj[val]);
};
